var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"customer-onboarding-list"},[_c('customer-onboarding-table',{attrs:{"teamFilter":_vm.teamFilter,"loading":_vm.loading,"prospects":_vm.prospects}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }